import React from 'react';
import { Menu } from 'semantic-ui-react';

//IMAGES
import CotalityLogo from '../../../image/CotalityLogo-header.svg';

export default function Header() {

    function redirectToURL(link) {
        window.location.href = link;
    }

    return (
        <header id="header">
            <Menu inverted>
                <Menu.Item
                    name="home"
                >
                    <img 
                        alt="Cotality"
                        id="cotality-logo"
                        className="logo-brand"
                        src={CotalityLogo}
                        onClick={() => {
                            redirectToURL('https://www.cotality.com/au/corestore')
                            ;
                        }}
                    />
                </Menu.Item>
            </Menu>
            
        </header>
    );
}
